
import * as React from 'react'
import {
    Text, View, TextInput, TouchableOpacity, ActivityIndicator, BackHandler, Image, KeyboardAvoidingView,
    Platform, ScrollView
} from 'react-native'
import { useTheme } from '@react-navigation/native'
import Axios from 'axios'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { showMessage } from "react-native-flash-message";
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import images from '../../assets/images'

export default React.memo(function Login({ navigation }) {
    const { colors } = useTheme()
    const [phone, setPhone] = React.useState('')
    const [otp, setOtp] = React.useState('')
    const [position, setPosition] = React.useState(0)
    const [progress, setProgress] = React.useState(false)
    const insets = useSafeAreaInsets()
    const scrollRef = React.useRef()

    React.useEffect(() => {
        const backAction = () => {
            BackHandler.exitApp()
            return true;
        };
        const backHandler = BackHandler.addEventListener('hardwareBackPress', backAction);
        return () => backHandler.remove();
    }, []);

    const getOtp = () => {
        setProgress(true)
        Axios.get(`/api/ceo/get-otp?phone=${phone}`)
            .then(res => {
                console.log(res)
                if (res.status === 200 && res.data.length > 0) {
                    setPosition(1)
                } else
                    showMessage({ message: "Lỗi", description: "Số điện thoại nhập vào không đúng!", type: "warning" })
                setProgress(false)
            }).catch(err => {
                setProgress(false)
                showMessage({ message: "Lỗi", description: "Có lỗi xảy ra trong quá trình đăng nhập!", type: "warning" })
            })
    }

    const verifyOtp = () => {
        setProgress(true)
        Axios.post(`/api/ceo/verify-otp`, { phone, otp })
            .then(res => {
                console.log(res)
                if (res.status === 200 && res.data.data.length > 0) {
                    Axios.defaults.baseURL = res.data.data[0].url
                    Axios.defaults.headers = {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': res.data.data[0].token_type + ' ' + res.data.data[0].access_token,
                        'partnerId': res.data.data[0]?.partner_id
                        }
                    _storeData(res.data.data)
                } else
                    showMessage({ message: "Lỗi", description: "Mã xác thực không đúng!", type: "warning" })
                setProgress(false)
            }).catch(err => {
                setProgress(false)
                showMessage({ message: "Lỗi", description: "Mã xác thực không đúng!", type: "warning" })
            })
    }

    const _storeData = async (data) => {
        try {
            const list_merchant = JSON.stringify(data)
            await AsyncStorage.setItem('list_merchant', list_merchant)
            const merchant = JSON.stringify(data[0])
            await AsyncStorage.setItem('merchant', merchant)
            navigation.replace('Home')
        } catch (error) {
            console.log(error)
        }
    };

    return (
        <KeyboardAvoidingView style={{ flex: 1, flexDirection: 'column', backgroundColor: colors.primary }}
            behavior={Platform.OS === 'ios' ? "padding" : "height"} >
            <ScrollView keyboardShouldPersistTaps="handled" keyboardDismissMode="none" ref={scrollRef}>
                <View>
                    <View style={{ alignItems: 'center', flexDirection: 'column' }}>
                        <Text style={{ fontSize: 36, lineHeight: 49, color: '#454545', fontFamily: 'Nunito_700Bold', marginTop: insets.top + 20 }}>HAIVAN+</Text>
                        <View style={{ alignItems: 'center', justifyContent: 'center', marginTop: 65, marginBottom: 65 }}>
                            <Image source={images.target} style={{ width: 120, height: 120, marginBottom: 24 }} resizeMode='contain' />
                            <Text style={{ fontSize: 24, lineHeight: 32, color: '#454545', fontFamily: 'Nunito_700Bold' }}>Business Operation Center</Text>
                            <Text style={{ fontSize: 18, lineHeight: 24, color: '#454545', fontFamily: 'Nunito_700Bold' }}>Hệ thống điều hành kinh doanh</Text>
                        </View>
                    </View>
                    {
                        position === 0 ? <View style={{ marginBottom: 24 }}>
                            <Text style={{
                                fontSize: 18, lineHeight: 24, color: '#454545', fontFamily: 'Nunito_700Bold', marginTop: 22, alignSelf: 'center'
                            }}>Xin mời nhập số điện thoại</Text>
                            <TextInput
                                autoCompleteType='off'
                                dataDetectorTypes='phoneNumber'
                                keyboardType='numeric'
                                autoCorrect={false}
                                style={[{
                                    height: 48, borderRadius: 10, backgroundColor: 'white', alignSelf: 'center', width: 300,
                                    marginTop: 24, paddingHorizontal: 17, fontFamily: 'Nunito_700Bold', fontSize: 16
                                }, Platform.OS === "web" && { outline: 'none' }]}
                                onChangeText={phone => setPhone(phone)}
                                value={phone}
                                placeholder='Số điện thoại'
                                underlineColorAndroid='transparent'
                                onFocus={(event) => {
                                    setTimeout(() => {
                                        scrollRef.current.scrollToEnd({ animated: true })
                                    }, 500);
                                }}
                            />
                            {
                                progress ? <View style={{ height: 48, justifyContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 24 }}>
                                    <ActivityIndicator size="small" color={colors.text} />
                                </View> : <TouchableOpacity style={{
                                    width: 300, backgroundColor: '#454545', borderRadius: 10, marginTop: 24,
                                    height: 48, justifyContent: 'center', alignItems: 'center', alignSelf: 'center'
                                }} onPress={getOtp}>
                                        <Text style={{ fontSize: 18, color: 'white', fontFamily: 'Nunito_900Black', alignSelf: 'center' }}>
                                            TIẾP TỤC
                                </Text>
                                    </TouchableOpacity>
                            }
                        </View> : <View style={{ marginBottom: 24 }}>
                                <Text style={{
                                    fontSize: 18, lineHeight: 24, color: '#454545', fontFamily: 'Nunito_700Bold', marginTop: 22, alignSelf: 'center'
                                }}>Vui lòng nhập mã xác thực</Text>
                                <TextInput
                                    autoCorrect={false}
                                    keyboardType='numeric'
                                    maxLength={6}
                                    style={[{
                                        height: 48, borderRadius: 10, backgroundColor: 'white', alignSelf: 'center', width: 300,
                                        marginTop: 24, paddingHorizontal: 17, fontFamily: 'Nunito_700Bold', fontSize: 16
                                    }, , Platform.OS === "web" && { outline: 'none' }]}
                                    onChangeText={text => setOtp(text)}
                                    value={otp}
                                    placeholder='Mã xác thực'
                                    underlineColorAndroid='transparent'
                                    onFocus={(event) => {
                                        setTimeout(() => {
                                            scrollRef.current.scrollToEnd({ animated: true })
                                        }, 500);
                                    }}
                                />
                                {
                                    progress ? <View style={{ height: 48, justifyContent: 'center', alignItems: 'center', alignSelf: 'center', marginTop: 24 }}>
                                        <ActivityIndicator size="small" color={colors.text} />
                                    </View> : <TouchableOpacity style={{
                                        width: 300, backgroundColor: '#454545', borderRadius: 10, marginTop: 24,
                                        height: 48, justifyContent: 'center', alignItems: 'center', alignSelf: 'center'
                                    }} onPress={verifyOtp}>
                                            <Text style={{ fontSize: 18, color: 'white', fontFamily: 'Nunito_900Black', alignSelf: 'center' }}>
                                                XÁC NHẬN
                                    </Text>
                                        </TouchableOpacity>
                                }
                            </View>
                    }
                </View>
            </ScrollView>
        </KeyboardAvoidingView>
    );
})
